import React from "react";
import {
  useClearRefinements,
  UseClearRefinementsProps,
} from "react-instantsearch";
import { translate } from "../../../Services/translation";

const CustomClearRefinements = (props: UseClearRefinementsProps) => {
  const { canRefine, refine } = useClearRefinements(props);

  return (
    <button
      disabled={!canRefine}
      onClick={refine}
      className="btn btn--secondary"
    >
      {translate("algolia.results.clear-refinements.title")}
    </button>
  );
};

export default CustomClearRefinements;
